<h2 mat-dialog-title>Delete {{ this.data.name }}?</h2>
<mat-progress-bar
  mode="indeterminate"
  color="accent"
  *ngIf="loading"
></mat-progress-bar>

<mat-dialog-content>
  <p>
    Are you sure you want to delete this college? This action cannot be undone.
  </p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="accent" (click)="onDelete()">Yes</button>
</mat-dialog-actions>
